import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { buttonStyling, iconStyling } from './styling';
import { LoaderIcon } from '../../icons';
export const Button = forwardRef(({ children, variant, size, intent, icon: Icon, isLoading, ...props }, ref) => {
    const IconComponent = Icon ? _jsx(Icon, { className: iconStyling({ size }) }) : null;
    return (_jsxs("button", { ref: ref, ...props, disabled: props.disabled || isLoading, className: buttonStyling({
            withIcon: Icon !== undefined,
            withChildren: children !== undefined,
            variant,
            size,
            intent,
            className: props.className,
        }), children: [isLoading ? _jsx(LoaderIcon, { className: iconStyling({ size }) }) : IconComponent, children] }));
});
Button.displayName = 'Button';
